import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelDCandidateDetail } from "../../types/leveld-reports";

export interface UseGetLevelDCandidateDetailOptions {
  examInstanceId: string | null;
  enabled?: boolean;
}

export function useGetLevelDCandidateDetail({
  examInstanceId,
  enabled = true,
}: UseGetLevelDCandidateDetailOptions) {
  const { t } = useTranslation();
  const axios = useAxios();

  return useQuery<LevelDCandidateDetail | null>({
    queryKey: ["levelDCandidateDetail", examInstanceId],
    queryFn: async () => {
      if (!examInstanceId) {
        return null;
      }

      try {
        const response = await axios.get<LevelDCandidateDetail>(
          `api/leveldreports/candidates/${examInstanceId}`
        );
        return response.data;
      } catch (error: unknown) {
        if ((error as { response?: { status: number } })?.response?.status === 404) {
          return null;
        }
        message.error(t("levelDReports.errors.getCandidateDetail"));
        throw error;
      }
    },
    enabled: enabled && !!examInstanceId,
    staleTime: 30 * 1000, // 30 seconds
    retry: 1,
  });
}
